var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_10421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70833 0.416626H2.29167C1.68408 0.417288 1.10157 0.658943 0.671944 1.08857C0.242317 1.5182 0.000661737 2.10071 0 2.70829L0 7.29163C0.000661737 7.89921 0.242317 8.48172 0.671944 8.91135C1.10157 9.34097 1.68408 9.58263 2.29167 9.58329H7.70833C8.31592 9.58263 8.89843 9.34097 9.32806 8.91135C9.75768 8.48172 9.99934 7.89921 10 7.29163V2.70829C9.99934 2.10071 9.75768 1.5182 9.32806 1.08857C8.89843 0.658943 8.31592 0.417288 7.70833 0.416626ZM7.70833 1.66663C7.96103 1.66747 8.20462 1.76102 8.39292 1.92954L5.68458 4.63788C5.50063 4.81357 5.25604 4.91161 5.00167 4.91161C4.74729 4.91161 4.5027 4.81357 4.31875 4.63788L1.61042 1.92954C1.79785 1.76178 2.04012 1.66828 2.29167 1.66663H7.70833ZM7.70833 8.33329H2.29167C2.0154 8.33329 1.75045 8.22355 1.5551 8.02819C1.35975 7.83284 1.25 7.56789 1.25 7.29163V3.34038L3.43292 5.52329C3.63865 5.72911 3.88292 5.89239 4.15177 6.00378C4.42062 6.11518 4.70878 6.17251 4.99979 6.17251C5.2908 6.17251 5.57897 6.11518 5.84782 6.00378C6.11667 5.89239 6.36093 5.72911 6.56667 5.52329L8.75 3.34038V7.29163C8.75 7.56789 8.64025 7.83284 8.4449 8.02819C8.24955 8.22355 7.9846 8.33329 7.70833 8.33329Z",
    fill: "#45185A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_10421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailsActive);
export default __webpack_public_path__ + "static/media/EmailsActive.dc77444ad24b0dbb2a558622fb4e1cde.svg";
export { ForwardRef as ReactComponent };